import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  EditButton,
  ShowButton,
  DeleteButton,
  ChipField,
  FunctionField,
  TopToolbar,
  CreateButton,
  ExportButton,
} from 'react-admin';

const SubscriptionPlanListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const SubscriptionPlanList = () => {
  return (
    <List actions={<SubscriptionPlanListActions />} title="Планы подписок">
      <Datagrid rowClick="show">
        <TextField source="name" label="Название" />
        <ChipField source="type" label="Тип" />
        <NumberField 
          source="price" 
          label="Цена" 
          options={{ style: 'currency', currency: 'USD' }}
        />
        <TextField source="currency" label="Валюта" />
        <NumberField source="billingPeriodMonths" label="Период (мес.)" />
        <BooleanField source="isActive" label="Активен" />
        <NumberField source="sortOrder" label="Порядок" />
        <FunctionField
          label="Лимитеры"
          render={(record: any) => record.limiters?.length || 0}
        />
        <EditButton />
        <ShowButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};
